import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Chip,
  Grid,
  FormControlLabel,
  Checkbox,
  Alert,
} from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import toast from "react-hot-toast";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { post } from "../apis/apis";
import CircularProgress from "@mui/material/CircularProgress";
import { unhashIds } from "./utlis";

const SignersDialog = ({
  open,
  onClose,
  signers,
  setSigners,
  signerToEdit,
  file_id,
  setAnnotationsd,
  annotations,
  templateDoc,
  primaryColorComp,
  // setSelectedSignerId,
  // setSelectedSigner,
}) => {
  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [email, setEmail] = useState("");
  const [accessCode, setAccessCode] = useState("");
  const [requireKba, setRequireKba] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [error, setError] = useState({});
  const [availableKbaCredits, setAvailableKbaCredits] = useState(null);
  const [kbaCreditsLoading, setKbaCreditsLoading] = useState(false);
  const [deletingSignerIndex, setDeletingSignerIndex] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [selectedSignerToDelete, setSelectedSignerToDelete] = useState(null);
  const handleDeleteClick = (index) => {
    setSelectedSignerToDelete(index);
    setDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = async () => {
    const index = selectedSignerToDelete;
    if (index === null) return;

    setDeletingSignerIndex(index);
    try {
      const signerToDelete = signers[index];
      if (!signerToDelete.signer_id && !signerToDelete.id) {
        toast.error("Invalid signer ID");
        return;
      }

      const postData = {
        signer_id: signerToDelete.signer_id || signerToDelete.id,
      };

      const apiData = await post("file/delete-signer", postData);

      if (apiData.error) {
        toast.error(apiData.message || "Failed to delete signer");
        return;
      }
      console.log("deleted signer ");

      const updatedSigners = signers.filter((_, i) => i !== index);
      const signersWithUpdatedColors = updatedSigners.map(
        (signer, newIndex) => ({
          ...signer,
          color: colors[newIndex],
          order_id: (newIndex + 1).toString(),
        })
      );

      setSigners(signersWithUpdatedColors);
      const newAnnotations = {};
      Object.entries(annotations).forEach(([pageNum, pageAnnotations]) => {
        if (pageNum === "_lastUpdate" || !Array.isArray(pageAnnotations)) return;
        const filteredAnnotations = pageAnnotations.filter(
          (annot) =>
            annot.signerId !== signerToDelete.signer_id &&
            annot.signer_id !== signerToDelete.signer_id
        );
        if (filteredAnnotations.length > 0) {
          newAnnotations[pageNum] = filteredAnnotations;
        }
      });
      setAnnotationsd(newAnnotations);

      toast.success("Signer deleted successfully");
      await updateSignerOrder(signersWithUpdatedColors);
      setName("");
      setEmail("");
      setAccessCode("");
      setRequireKba(false);
      setEditingIndex(null);
      setError({});
    } catch (error) {
      console.error("Error deleting signer:", error);
      toast.error("Error deleting signer");
    } finally {
      setDeletingSignerIndex(null);
      setDeleteConfirmOpen(false);
      setSelectedSignerToDelete(null);
    }
  };
  const generateSignerId = () => {
    return Math.floor(1000 + Math.random() * 9000).toString();
  };
  const onDragEnd = (result) => {
    if (!result.destination || !signers.length) return;

    const items = Array.from(signers);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    // Update colors and order_id based on new positions
    const updatedSigners = items.map((signer, index) => ({
      ...signer,
      color: colors[index],
      order_id: index + 1, // Add order_id starting from 1
    }));

    setSigners(updatedSigners);

    // Call API to update order
    updateSignerOrder(updatedSigners);
  };
  // const onDragEnd = (result) => {
  //   if (!result.destination || !signers.length) return;

  //   const items = Array.from(signers);
  //   const [reorderedItem] = items.splice(result.source.index, 1);
  //   items.splice(result.destination.index, 0, reorderedItem);

  //   // Update colors based on new positions
  //   const updatedSigners = items.map((signer, index) => ({
  //     ...signer,
  //     color: colors[index],
  //   }));

  //   setSigners(updatedSigners);
  // };
  // Add effect to populate form when signerToEdit changes
  useEffect(() => {
    if (signerToEdit) {
      setName(signerToEdit.signer.name);
      setEmail(signerToEdit.signer.email);
      setAccessCode(signerToEdit.signer.access_code || "");
      setRequireKba(signerToEdit.signer.require_kba || signerToEdit.signer.requireKba || false);
      setEditingIndex(signerToEdit.index);
    }
  }, [signerToEdit]);
  useEffect(() => {
    if (templateDoc === true) {
      setName(`Signer ${signers.length + 1}`);
    }
  }, [templateDoc]);
  const getCurrentUserId = () => {
    const params = new URLSearchParams(window.location.search);
    const directUserId = params.get("user_id");
    if (directUserId) return directUserId;

    const hashedData = params.get("data");
    if (hashedData) {
      const unhashedData = unhashIds(hashedData);
      const hashedUserId =
        unhashedData?.userId ??
        unhashedData?.user_id ??
        unhashedData?.result?.user_id;
      if (hashedUserId) return hashedUserId;
    }

    try {
      const userDataRaw = localStorage.getItem("user_data");
      if (userDataRaw) {
        const parsedUserData = JSON.parse(userDataRaw);
        const parsedUserId =
          parsedUserData?.user_id ||
          parsedUserData?.userId ||
          parsedUserData?.user?.user_id ||
          parsedUserData?.user?.userId ||
          parsedUserData?.result?.user_id;
        if (parsedUserId) return parsedUserId;
      }
    } catch (err) {
      console.error("Failed to parse user_data for KBA credits", err);
    }

    try {
      const userRaw = localStorage.getItem("user");
      if (userRaw) {
        const parsedUser = JSON.parse(userRaw);
        const parsedUserId =
          parsedUser?.user_id ||
          parsedUser?.userId ||
          parsedUser?.user?.user_id ||
          parsedUser?.user?.userId ||
          parsedUser?.result?.user_id;
        if (parsedUserId) return parsedUserId;
      }
    } catch (err) {
      console.error("Failed to parse user for KBA credits", err);
    }

    return null;
  };
  const fetchAvailableKbaCredits = async () => {
    const userId = getCurrentUserId();
    if (!userId) {
      setAvailableKbaCredits(null);
      return;
    }

    setKbaCreditsLoading(true);
    try {
      const apiData = await post("api/kba-credits/get", { user_id: userId });
      if (!apiData?.error) {
        const credits =
          apiData?.kbaCreditsRemaining ?? apiData?.result?.kbaCreditsRemaining;
        if (credits !== undefined && credits !== null) {
          setAvailableKbaCredits(Number(credits));
        }
      }
    } catch (err) {
      console.error("Failed to fetch KBA credits", err);
    } finally {
      setKbaCreditsLoading(false);
    }
  };
  useEffect(() => {
    if (open) {
      fetchAvailableKbaCredits();
    }
  }, [open]);

  const getSignerKbaStatus = (signer) =>
    Boolean(signer?.require_kba || signer?.requireKba);
  const existingKbaSignersCount = signers.filter(getSignerKbaStatus).length;
  const projectedKbaSignersCount =
    editingIndex !== null
      ? existingKbaSignersCount +
      (requireKba === getSignerKbaStatus(signers[editingIndex] || {})
        ? 0
        : requireKba
          ? 1
          : -1)
      : existingKbaSignersCount + (requireKba ? 1 : 0);
  const isKbaCreditsLow =
    typeof availableKbaCredits === "number" &&
    projectedKbaSignersCount > availableKbaCredits;
  const kbaCreditsRemainingNow =
    typeof availableKbaCredits === "number"
      ? availableKbaCredits - existingKbaSignersCount
      : null;
  const kbaCreditsRemainingProjected =
    typeof availableKbaCredits === "number"
      ? availableKbaCredits - projectedKbaSignersCount
      : null;
  const hasNoKbaCredits =
    typeof kbaCreditsRemainingNow === "number" && kbaCreditsRemainingNow <= 0;
  const isKbaCheckboxDisabled =
    kbaCreditsLoading || (hasNoKbaCredits && !requireKba);
  const isKbaSelectionBlocked = requireKba && isKbaCreditsLow;
  const handleBuyKbaCredits = () => {
    const isLocal = window.location.hostname.includes("localhost");
    const portalBaseUrl = isLocal
      ? "http://localhost:3001"
      : "https://portal.requiresign.com";
    window.open(`${portalBaseUrl}/home?infoTab=true`, "_blank");
  };
  const colors = [
    "rgb(255 226 139 / 98%)",
    "rgb(192 165 207 / 98%)",
    "rgb(151 201 191 / 98%)",
    "rgb(247 185 148 / 98%)",
    "rgb(207 219 127 / 98%)",
    "rgb(255 153 128 / 98%)",
    "rgb(255 179 198 / 98%)",
    "rgb(230 198 230 / 98%)",
  ];
  // const colors = [
  //   "rgb(255 240 190 / 90%)", // Lighter yellow
  //   "rgb(220 205 230 / 90%)", // Lighter purple
  //   "rgb(190 225 215 / 90%)", // Lighter teal
  //   "rgb(250 215 190 / 90%)", // Lighter peach
  //   "rgb(230 238 180 / 90%)", // Lighter lime
  //   "rgb(255 190 175 / 90%)", // Lighter coral
  //   "rgb(255 210 225 / 90%)", // Lighter pink
  //   "rgb(240 220 240 / 90%)", // Lighter lavender
  // ];
  const validateForm = () => {
    const newError = {};

    if (!name.trim()) newError.name = "Name is required";
    if (!email.trim()) {
      newError.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newError.email = "Invalid email format";
    } else {
      // Check for duplicate email
      const isDuplicate = signers.some((signer, index) => {
        // If we're editing, exclude the current signer from the check
        if (editingIndex !== null && index === editingIndex) {
          return false;
        }
        return signer.email.toLowerCase() === email.toLowerCase();
      });

      if (isDuplicate) {
        newError.email = "This email is already assigned to another signer";
      }
    }
    // Only validate access code if it's not empty
    // Optional access code validation - only check if there's a value
    if (accessCode && accessCode.trim()) {
      if (!/^\d{6}$/.test(accessCode)) {
        newError.accessCode = "Access code must be exactly 6 digits";
      }
    }

    setError(newError);
    return Object.keys(newError).length === 0;
  };

  const handleSubmit11 = async () => {
    if (!validateForm()) return;

    if (signers.length >= 8 && editingIndex === null) {
      toast.error("Maximum 8 signers allowed");
      return;
    }

    if (editingIndex !== null) {
      // Edit existing signer
      const updatedSigners = [...signers];
      updatedSigners[editingIndex] = {
        ...updatedSigners[editingIndex],
        name,
        email,
        access_code: accessCode, // Use access_code instead of accessCode
        require_kba: requireKba,
        color: colors[editingIndex],
      };
      setSigners(updatedSigners);
      toast.success("Signer updated successfully");
    } else {
      // Add new signer
      const newSigner = {
        id: generateSignerId(),
        name,
        email,
        access_code: accessCode, // Use access_code instead of accessCode
        require_kba: requireKba,
        color: colors[signers.length % colors.length],
        order_id: signers.length + 1, // Add order_id for new signer
      };
      setSigners([...signers, newSigner]);
      toast.success("Signer added successfully");
    }
    const updateData = {
      signers: signers,
      file_id: file_id,
    };

    const updateResponse = await post("file/add-signer", updateData);
    console.log(updateResponse);

    clearForm();
  };
  // const handleSubmit = async () => {
  //   console.log("signer", signers);
  //   if (!validateForm()) return;

  //   if (signers.length >= 8 && editingIndex === null) {
  //     toast.error("Maximum 8 signers allowed");
  //     return;
  //   }
  //   setIsSubmitting(true);
  //   try {
  //     let updatedSignersList = [...signers];

  //     if (editingIndex !== null) {
  //       // Edit existing signer
  //       const updatedSigner = {
  //         ...updatedSignersList[editingIndex],
  //         name,
  //         email,
  //         access_code: accessCode,
  //         color: colors[editingIndex],
  //       };
  //       updatedSignersList[editingIndex] = updatedSigner;
  //     } else {
  //       // Add new signer
  //       const newSigner = {
  //         id: generateSignerId(),
  //         name,
  //         email,
  //         access_code: accessCode,
  //         color: colors[signers.length % colors.length],
  //         order_id: signers.length + 1,
  //       };
  //       updatedSignersList = [...signers, newSigner];
  //     }

  //     // Prepare API data with file_id and all signers

  //     const apiData = {
  //       file_id: file_id,
  //       signers: updatedSignersList.map((signer) => {
  //         const signerData = {
  //           name: signer.name,
  //           email: signer.email,
  //           access_code: signer.access_code,
  //           order_id: signer.order_id,
  //           color: signer.color,
  //         };

  //         // Only add signer_id if it exists
  //         if (signer.signer_id) {
  //           signerData.signer_id = signer.signer_id;
  //         }

  //         return signerData;
  //       }),
  //     };

  //     const response = await post("file/add-signer-editor", apiData);
  //     console.log(response);
  //     if (response.error) {
  //       toast.error(response.message || "Failed to update signers");
  //       return;
  //     }

  //     // Update local state with API response data if available
  //     if (response.data) {
  //       setSigners(response.data);
  //     } else {
  //       setSigners(updatedSignersList);
  //     }

  //     toast.success(
  //       editingIndex !== null
  //         ? "Signer updated successfully"
  //         : "Signer added successfully"
  //     );
  //     clearForm();
  //   } catch (error) {
  //     console.error("Error handling signer:", error);
  //     toast.error("An error occurred while processing your request");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    if (signers.length >= 8 && editingIndex === null) {
      toast.error("Maximum 8 signers allowed");
      return;
    }
    if (isKbaSelectionBlocked) {
      toast.error("Insufficient KBA credits. Please buy more credits.");
      return;
    }

    setIsSubmitting(true);
    try {
      let updatedSignersList = [...signers];

      if (editingIndex !== null) {
        // Edit existing signer
        const updatedSigner = {
          ...updatedSignersList[editingIndex],
          name,
          email,
          access_code: accessCode,
          require_kba: requireKba,
          color: colors[editingIndex],
          // Preserve the existing signer_id
          signer_id: updatedSignersList[editingIndex].signer_id,
        };
        updatedSignersList[editingIndex] = updatedSigner;
      } else {
        // Add new signer
        const newSigner = {
          name,
          email,
          access_code: accessCode,
          require_kba: requireKba,
          color: colors[signers.length % colors.length],
          order_id: signers.length + 1,
          // No signer_id for new signers
        };
        updatedSignersList = [...signers, newSigner];
      }

      const apiData = {
        file_id: file_id,
        signers: updatedSignersList.map((signer) => ({
          name: signer.name,
          email: signer.email,
          access_code: signer.access_code,
          require_kba: signer.require_kba,
          order_id: signer.order_id,
          color: signer.color,
          signer_id: signer.signer_id, // Will be undefined for new signers
        })),
      };

      const response = await post("file/add-signer-editor", apiData);

      if (response.error) {
        toast.error(response.message || "Failed to update signers");
        return;
      }

      // Update state with response data
      setSigners(response.data);

      toast.success(
        editingIndex !== null
          ? "Signer updated successfully"
          : "Signer added successfully"
      );
      clearForm();
      if (editingIndex !== null) {
        return response.data[editingIndex]; // Return the updated signer
      } else {
        return response.data[response.data.length - 1]; // Return the last signer (newly added)
      }
    } catch (error) {
      console.error("Error handling signer:", error);
      toast.error("An error occurred while processing your request");
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSubmit1 = async () => {
    if (!validateForm()) return;

    if (signers.length >= 8 && editingIndex === null) {
      toast.error("Maximum 8 signers allowed");
      return;
    }

    try {
      if (editingIndex !== null) {
        // Edit existing signer
        const updatedSigners = [...signers];
        const signerToUpdate = {
          ...updatedSigners[editingIndex],
          name,
          email,
          access_code: accessCode,
          require_kba: requireKba,
          color: colors[editingIndex],
        };

        // API call to update signer
        const updateData = {
          signer_id: signerToUpdate.id,
          name: signerToUpdate.name,
          email: signerToUpdate.email,
          access_code: signerToUpdate.access_code,
          require_kba: signerToUpdate.require_kba,
          order_id: signerToUpdate.order_id,
        };

        const updateResponse = await post("file/add-signer", updateData);

        if (updateResponse.error) {
          toast.error(updateResponse.message || "Failed to update signer");
          return;
        }

        updatedSigners[editingIndex] = signerToUpdate;
        setSigners(updatedSigners);
        toast.success("Signer updated successfully");
      } else {
        // Add new signer
        const newSigner = {
          id: generateSignerId(),
          name,
          email,
          access_code: accessCode,
          require_kba: requireKba,
          color: colors[signers.length % colors.length],
          order_id: signers.length + 1,
        };

        // API call to add signer
        const addData = {
          name: newSigner.name,
          email: newSigner.email,
          access_code: newSigner.access_code,
          require_kba: newSigner.require_kba,
          order_id: newSigner.order_id,
          color: newSigner.color,
        };

        const addResponse = await post("file/add-signer", addData);

        if (addResponse.error) {
          toast.error(addResponse.message || "Failed to add signer");
          return;
        }

        // Use the ID from the API response if provided
        const signerWithId = {
          ...newSigner,
          id: addResponse.data?.id || newSigner.id,
        };

        setSigners([...signers, signerWithId]);
        toast.success("Signer added successfully");
      }

      clearForm();
    } catch (error) {
      console.error("Error handling signer:", error);
      toast.error("An error occurred while processing your request");
    }
  };
  const handleEdit = (index) => {
    const signer = signers[index];
    setName(signer.name);
    setEmail(signer.email);
    setAccessCode(signer.access_code || "");
    setRequireKba(signer.require_kba || signer.requireKba || false);
    setEditingIndex(index);
  };
  // Add function to update order in backend
  const updateSignerOrder = async (updatedSigners) => {
    try {
      const postData = {
        signers: updatedSigners.map((signer) => ({
          signer_id: signer.signer_id,
          color: signer.color,
          order_id: signer.order_id,
        })),
      };
      console.log(postData);
      const apiData = await post("file/update-signer-order", postData);
      console.log("uodate signer ", apiData);
      if (apiData.error) {
        toast.error("Failed to update signer order");
      }
    } catch (error) {
      console.error("Error updating signer order:", error);
      toast.error("Error updating signer order");
    }
  };
  // const handleDelete = async (index) => {
  //   // Get the signer object before removing from array
  //   const signerToDelete = signers[index];

  //   const updatedSigners = signers.filter((_, i) => i !== index);

  //   // Reassign colors based on new indices
  //   const signersWithUpdatedColors = updatedSigners.map((signer, newIndex) => ({
  //     ...signer,
  //     color: colors[newIndex],
  //   }));

  //   // Create post data with correct signer_id
  //   const postData = {
  //     signer_id: signerToDelete.signer_id, // Use the actual signer ID
  //   };

  //   try {
  //     const apiData = await post("file/delete-signer", postData);

  //     if (apiData.error) {
  //       toast.error("Failed to delete signer");
  //       return;
  //     }

  //     // Only update state if API call was successful
  //     setSigners(signersWithUpdatedColors);
  //     toast.success("Signer deleted successfully");
  //   } catch (error) {
  //     console.error("Error deleting signer:", error);
  //     toast.error("Error deleting signer");
  //   }
  // };
  // Update handleDelete function
  const handleDelete1 = async (index) => {
    const signerToDelete = signers[index];
    const updatedSigners = signers.filter((_, i) => i !== index);

    // Reassign colors and update order_ids
    const signersWithUpdatedColors = updatedSigners.map((signer, newIndex) => ({
      ...signer,
      color: colors[newIndex],
      order_id: newIndex + 1, // Reassign order_id after deletion
    }));

    const postData = {
      signer_id: signerToDelete.signer_id,
    };

    try {
      const apiData = await post("file/delete-signer", postData);

      if (apiData.error) {
        toast.error("Failed to delete signer");
        return;
      }
      console.log("fdleye", apiData);

      setSigners(signersWithUpdatedColors);
      toast.success("Signer deleted successfully");

      // Update order after successful deletion
      await updateSignerOrder(signersWithUpdatedColors);
    } catch (error) {
      console.error("Error deleting signer:", error);
      toast.error("Error deleting signer");
    }
  };
  const handleDelete = async (index) => {
    const signerToDelete = signers[index];

    // Check if we have a valid signer_id
    if (!signerToDelete.signer_id && !signerToDelete.id) {
      toast.error("Invalid signer ID");
      return;
    }

    try {
      const postData = {
        signer_id: signerToDelete.signer_id || signerToDelete.id,
      };

      const apiData = await post("file/delete-signer", postData);
      console.log("Delete response:", apiData);

      if (apiData.error) {
        toast.error(apiData.message || "Failed to delete signer");
        return;
      }

      // Only update state if API call was successful
      const updatedSigners = signers.filter((_, i) => i !== index);

      // Reassign colors and update order_ids
      const signersWithUpdatedColors = updatedSigners.map(
        (signer, newIndex) => ({
          ...signer,
          color: colors[newIndex],
          order_id: (newIndex + 1).toString(), // Convert to string to match schema
        })
      );

      setSigners(signersWithUpdatedColors);
      toast.success("Signer deleted successfully");

      // Update order after successful deletion
      await updateSignerOrder(signersWithUpdatedColors);
    } catch (error) {
      console.error("Error deleting signer:", error);
      toast.error("Error deleting signer");
    }
  };
  const clearForm = () => {
    setName("");
    setEmail("");
    setAccessCode("");
    setRequireKba(false);
    setEditingIndex(null);
    setError({});
  };
  // Update onClose handler
  const handleClose = () => {
    clearForm();
    onClose();
    // if (signers.length > 0) {
    //   const lastAddedSigner = signers[signers.length - 1];
    //   console.log("Last added signer:", lastAddedSigner);
    //   onClose(lastAddedSigner);
    // } else {
    //   onClose();
    // }
  };
  // Create a new function to handle the save and close logic
  const handleSaveAndClose = async () => {
    // Check if any fields have values
    if (name.trim() || email.trim() || accessCode.trim()) {
      // There are values, so we need to validate and save
      if (!validateForm()) {
        // Validation failed, don't close the modal
        return;
      }

      // Proceed with save operation
      setIsSubmitting(true);
      try {
        // Get the result of the submit operation (new signer or updated signer)
        const newSigner = await handleSubmit();

        // If a new signer was added (not updating), select it as the active one
        // if (editingIndex === null && result) {
        //   console.log("New signer added:", result);
        //   // Use the returned signer directly
        //   if (setSelectedSignerId && setSelectedSigner) {
        //     setSelectedSignerId(result.signer_id);
        //     setSelectedSigner(result);
        //   }
        // } // After successful save, close the dialog
        clearForm();
        onClose(newSigner); // Pass the new signer to parent component
      } catch (error) {
        console.error("Error saving signer:", error);
        toast.error("Error occurred while saving");
        // Don't close on error
        setIsSubmitting(false);
      }
    } else {
      // All fields are empty, just close the dialog
      clearForm();
      onClose();
    }
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            height: "80vh", // Set maximum height
            maxHeight: "80vh",
          },
        }}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Manage Signers
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={5} style={{ marginTop: "10px" }}>
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="body2"
                  sx={{
                    mb: 1,
                    color: "text.secondary",
                    fontWeight: 500,
                  }}
                >
                  Name *
                </Typography>
                <TextField
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  error={!!error.name}
                  helperText={error.name}
                  sx={{
                    mb: 1,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      height: "40px", // Add this
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 14px", // Add this
                    },
                    "& .MuiFormHelperText-root": {
                      marginTop: "4px", // Add this
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                />

                <Typography
                  variant="body2"
                  sx={{
                    mb: 1,
                    color: "text.secondary",
                    fontWeight: 500,
                  }}
                >
                  Email *
                </Typography>
                <TextField
                  fullWidth
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={!!error.email}
                  helperText={error.email}
                  sx={{
                    mb: 1,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      height: "40px", // Add this
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 14px", // Add this
                    },
                    "& .MuiFormHelperText-root": {
                      marginTop: "4px", // Add this
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                />

                <Typography
                  variant="body2"
                  sx={{
                    mb: 1,
                    color: "text.secondary",
                    fontWeight: 500,
                  }}
                >
                  Access Code (Requirement 6 digits)
                </Typography>
                <TextField
                  fullWidth
                  value={accessCode}
                  onChange={(e) => setAccessCode(e.target.value.slice(0, 6))}
                  error={!!error.accessCode}
                  helperText={error.accessCode}
                  sx={{
                    mb: 1,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      height: "40px", // Add this
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 14px", // Add this
                    },
                    "& .MuiFormHelperText-root": {
                      marginTop: "4px", // Add this
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 6 }}
                  variant="outlined"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={requireKba}
                      onChange={(e) => setRequireKba(e.target.checked)}
                      disabled={isKbaCheckboxDisabled}
                      sx={{
                        color: primaryColorComp || "rgb(35, 179, 232)",
                        "&.Mui-checked": {
                          color: primaryColorComp || "rgb(35, 179, 232)",
                        },
                      }}
                    />
                  }
                  label="Add KBA for this user"
                  sx={{
                    mt: 2,
                    mb: 0,
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    mb: 1,
                    fontSize: "13px",
                    color: "#5e5873",
                    fontWeight: 600,
                  }}
                >
                  KBA credits remaining:{" "}
                  {kbaCreditsLoading
                    ? "Loading..."
                    : typeof kbaCreditsRemainingProjected === "number"
                      ? Math.max(kbaCreditsRemainingProjected, 0)
                      : "Not available"}
                </Typography>
                {(hasNoKbaCredits || isKbaCreditsLow) && (
                  <Alert
                    severity="warning"
                    sx={{
                      mb: 1,
                      borderRadius: "8px",
                      alignItems: "center",
                      "& .MuiAlert-message": {
                        width: "100%",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1,
                        width: "100%",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "12px", fontWeight: 600, lineHeight: 1.3 }}
                      >
                        {hasNoKbaCredits
                          ? "Please buy credits to enable KBA."
                          : "Not enough KBA credits for selected signers."}
                      </Typography>
                      <Button
                        size="small"
                        variant="contained"
                        onClick={handleBuyKbaCredits}
                        sx={{
                          minWidth: "78px",
                          fontSize: "11px",
                          boxShadow: "none",
                          textTransform: "none",
                          bgcolor: primaryColorComp || "rgb(35, 179, 232)",
                          "&:hover": {
                            boxShadow: "none",
                            bgcolor: primaryColorComp || "#0085b5",
                          },
                        }}
                      >
                        Buy now
                      </Button>
                    </Box>
                  </Alert>
                )}
              </Box>

              <Button
                variant="contained"
                disabled={isSubmitting || isKbaSelectionBlocked}
                onClick={handleSubmit}
                sx={{
                  marginTop: 0,
                  boxShadow: "none",
                  bgcolor:
                    editingIndex !== null
                      ? "#28c76f"
                      : primaryColorComp === null ||
                        primaryColorComp === undefined
                        ? "rgb(35, 179, 232)"
                        : primaryColorComp,
                  "&:hover": {
                    boxShadow: "none",
                    bgcolor:
                      editingIndex !== null
                        ? "#17aa59"
                        : primaryColorComp === null ||
                          primaryColorComp === undefined
                          ? "#0085b5"
                          : primaryColorComp,
                  },
                  "&.Mui-disabled": {
                    bgcolor:
                      editingIndex !== null
                        ? "rgba(40, 199, 111, 0.7)"
                        : primaryColorComp === null ||
                          primaryColorComp === undefined
                          ? "rgba(35, 179, 232, 0.7)"
                          : primaryColorComp,
                    color: "white",
                  },
                  minWidth: "120px", // Ensure consistent width
                  position: "relative", // For loader positioning
                  minHeight: "40px",
                }}
              >
                {isSubmitting ? (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: "white",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      marginTop: "-12px",
                      marginLeft: "-12px",
                    }}
                  />
                ) : editingIndex !== null ? (
                  "Update Signer"
                ) : (
                  "Add Signer"
                )}
              </Button>
            </Grid>
            <Grid item xs={12} sm={7}>
              <Typography variant="h6">
                Signers List ({signers.length}/8)
              </Typography>
              <Typography variant="h6" sx={{ mb: 1, fontSize: "12px" }}>
                Drag and drop to reorder
              </Typography>
              {/* // Replace your existing List with this */}
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="signers-list">
                  {(provided) => (
                    <List
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      sx={{
                        maxHeight: "60vh",
                        overflowY: "auto",
                        "& ::-webkit-scrollbar": { width: 6 },
                        "& ::-webkit-scrollbar-thumb": {
                          backgroundColor: "#ccc",
                          borderRadius: 3,
                        },
                      }}
                    >
                      {signers.length === 0 ? (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "200px",
                            backgroundColor: "rgba(0, 0, 0, 0.02)",
                            borderRadius: "8px",
                            border: "1px dashed rgba(0, 0, 0, 0.12)",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              color: "text.secondary",
                              textAlign: "center",
                              mb: 1,
                            }}
                          >
                            No signers added yet
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.disabled",
                              textAlign: "center",
                            }}
                          >
                            Add signers using the form on the left
                          </Typography>
                        </Box>
                      ) : (
                        <>
                          {signers.map((signer, index) => (
                            <Draggable
                              key={signer.id || `signer-${index}`}
                              draggableId={signer.id || `signer-${index}`}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <ListItem
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  ref={provided.innerRef}
                                  sx={{
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    mb: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    background: snapshot.isDragging
                                      ? "rgba(0, 0, 0, 0.02)"
                                      : "white",
                                    "&:hover": {
                                      background: "rgba(0, 0, 0, 0.02)",
                                    },
                                  }}
                                >
                                  <div
                                    {...provided.dragHandleProps}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginRight: "10px",
                                      cursor: "grab",
                                    }}
                                  >
                                    <DragIndicatorIcon
                                      sx={{ color: "#757575" }}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      backgroundColor:
                                        signer.color || colors[index],
                                      marginRight: "10px",
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                      flexShrink: 0,
                                    }}
                                  />
                                  <ListItemText
                                    primary={
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                        }}
                                      >
                                        <Typography
                                          variant="caption"
                                          sx={{ color: "text.secondary" }}
                                        >
                                          #{signer.order_id}
                                        </Typography>
                                        <Typography
                                          variant="subtitle1"
                                          sx={{ fontWeight: 500 }}
                                        >
                                          {signer.name}
                                        </Typography>
                                      </Box>
                                    }
                                    secondary={
                                      <Box sx={{ mt: 0.5 }}>
                                        <Typography
                                          component="span"
                                          variant="body2"
                                        >
                                          {signer.email}
                                        </Typography>
                                        <br />
                                        {/* <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{
                                      fontFamily: "monospace",
                                      color: accessCode ? "#2c3e50" : "#95a5a6",
                                    }}
                                  >
                                    Access Code:{" "}
                                    {signer.accessCode || "Not set"}
                                  </Typography> */}
                                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 0.5 }}>
                                          <Chip
                                            label={`Access Code: ${signer.access_code || "Not set"
                                              }`}
                                            size="small"
                                            sx={{
                                              height: "20px",
                                              fontFamily: "monospace",
                                              fontSize: "12px",
                                              backgroundColor: signer.access_code
                                                ? "rgba(44, 62, 80, 0.1)"
                                                : "rgba(149, 165, 166, 0.1)",
                                              color: signer.access_code
                                                ? "#2c3e50"
                                                : "#95a5a6",
                                              "& .MuiChip-label": {
                                                px: 1,
                                              },
                                            }}
                                          />
                                          {(signer.require_kba || signer.requireKba) && (
                                            <Chip
                                              label="KBA Required"
                                              size="small"
                                              sx={{
                                                height: "20px",
                                                fontSize: "12px",
                                                backgroundColor: "rgba(40, 199, 111, 0.1)",
                                                color: "#28c76f",
                                                fontWeight: 500,
                                                "& .MuiChip-label": {
                                                  px: 1,
                                                },
                                              }}
                                            />
                                          )}
                                        </Box>
                                      </Box>
                                    }
                                  />
                                  <ListItemSecondaryAction>
                                    <IconButton
                                      edge="end"
                                      onClick={() => handleEdit(index)}
                                    >
                                      <EditIcon />
                                    </IconButton>
                                    {/* <IconButton
                                    edge="end"
                                    onClick={() => handleDelete(index)}
                                    sx={{ color: "#ea5455" }}
                                  >
                                    <DeleteIcon />
                                  </IconButton> */}
                                    <IconButton
                                      edge="end"
                                      onClick={() => handleDeleteClick(index)}
                                      disabled={deletingSignerIndex === index}
                                      sx={{
                                        color: "#ea5455",
                                        position: "relative",
                                      }}
                                    >
                                      {deletingSignerIndex === index ? (
                                        <CircularProgress
                                          size={24}
                                          sx={{
                                            color: "#ea5455",
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            marginTop: "-12px",
                                            marginLeft: "12px",
                                          }}
                                        />
                                      ) : (
                                        <DeleteIcon />
                                      )}
                                    </IconButton>
                                  </ListItemSecondaryAction>
                                </ListItem>
                              )}
                            </Draggable>
                          ))}
                        </>
                      )}
                      {provided.placeholder}
                    </List>
                  )}
                </Droppable>
              </DragDropContext>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={isSubmitting}
            // onClick={handleClose}
            onClick={handleSaveAndClose}
            sx={{
              textTransform: "none",
              color: "white",
              fontWeight: 600,
              backgroundColor:
                primaryColorComp === null || primaryColorComp === undefined
                  ? "#21b3e8"
                  : primaryColorComp,
              boxShadow: "none",
              position: "relative", // Add this for loader positioning
              "&:hover": {
                boxShadow: "none",
                backgroundColor:
                  primaryColorComp === null || primaryColorComp === undefined
                    ? "#00bcff"
                    : primaryColorComp,
              },
              // "&.Mui-disabled": {
              //   backgroundColor: "rgba(249, 164, 77, 0.7)",
              //   color: "white",
              // },
            }}
          >
            {isSubmitting ? (
              <>
                <CircularProgress
                  size={24}
                  sx={{
                    color: "white",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
                <span>Save & Close</span>{" "}
              </>
            ) : (
              "Save & Close"
            )}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Add this inside your main Dialog component, before the closing tag */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this signer? This action cannot be
            undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteConfirmOpen(false)}
            sx={{
              color: "text.secondary",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            color="error"
            variant="contained"
            sx={{
              bgcolor: "#ea5455",
              boxShadow: "none",
              "&:hover": {
                bgcolor: "#d63031",
                boxShadow: "none",
              },
            }}
          >
            <CircularProgress
              size={20}
              color="inherit"
              sx={{
                display:
                  deletingSignerIndex === selectedSignerToDelete
                    ? "block"
                    : "none",
              }}
            />
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SignersDialog;
